import { DataSource, Label, Layout, Panel, Table,} from "@mcleod/components";

export abstract class AutogenLayoutUserGroups extends Layout {
	labelGroupMembership: Label;
	labelGroups: Label;
	labelUsersInGroup: Label;
	labelUsersNotInGroup: Label;
	panelGroups: Panel;
	panelMembership: Panel;
	panelUsersInGroup: Panel;
	panelUsersNotInGroup: Panel;
	sourceUserGroup: DataSource;
	sourceUsersInGroup: DataSource;
	sourceUsersNotInGroup: DataSource;
	tableGroups: Table;
	tableUsersInGroup: Table;
	tableUsersNotInGroup: Table;
}
